import {createStandaloneToast} from '@chakra-ui/react'
import {
  createUserWithEmailAndPassword,
  fetchSignInMethodsForEmail,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updateProfile,
} from 'firebase/auth'
import {doc, onSnapshot, setDoc} from 'firebase/firestore'
import {ObjectMapper} from 'json-object-mapper'
import {useState} from 'react'
import useAsyncEffect from 'use-async-effect'
import shallow from 'zustand/shallow'
import {User as FirestoreUser} from '../models/User'
import {sessionStore} from '../stores/session/sessionStore'
import {DB_USERS, isDevOrPreview, TOAST_DURATION} from '../utils/consts'
import {auth, db, googleProvider} from './firebase'

export const fetchCheckEmail = async (email: string) => {
  return (await fetchSignInMethodsForEmail(auth, email)).length > 0
}

export const fetchCheckEmailProvider = async (email: string) => {
  return (await fetchSignInMethodsForEmail(auth, email)).pop()
}

export const fetchCreateAccountWEmail = async (email: string, password: string) => {
  return await createUserWithEmailAndPassword(auth, email, password)
}

export const fetchLoginWEmail = async (email: string, password: string) => {
  await signInWithEmailAndPassword(auth, email, password)
}

export const fetchLoginWGoogle = async () => {
  await signInWithPopup(auth, googleProvider)
}

export const fetchLogout = async () => {
  await signOut(auth)
}

export const fetchSetUser = async (user: string, data: any, complete?: boolean) => {
  await setDoc(doc(db, DB_USERS, user), data, {merge: true})
  complete &&
    (await updateProfile(sessionStore.getState().sessionUser!, {
      displayName: `${data.firstName} ${data.lastName}`,
    }))
}

///Start this one up on the app.tsx to let the session store update on nex user data.
export const InitMonitorUserLoggedIn = () => {
  const [uid, setUid] = useState<string | null>(null)
  const {setSession, setUser, setLoading} = sessionStore(
    state => ({
      setSession: state.setSessionUser,
      setUser: state.setUser,
      setLoading: state.setLoading,
    }),
    shallow
  )
  const toast = createStandaloneToast()

  //Monitor the auth session
  useAsyncEffect(isMounted => {
    return onAuthStateChanged(auth, user => {
      if (isMounted()) {
        setSession(user)
        setUid(user?.uid || null)
      }
    })
  })

  //Monitor the firestore session when uid exists
  useAsyncEffect(
    isMounted => {
      if (uid) {
        return onSnapshot(doc(db, DB_USERS, uid), doc => {
          if (isMounted()) {
            if (doc.exists()) {
              setUser(ObjectMapper.deserialize(FirestoreUser, {id: doc.id, ...doc.data()}))
            } else {
              setUser(null)
              fetchLogout()
              isDevOrPreview &&
                toast({
                  title: 'Error',
                  description: 'Your account data are corrupted',
                  status: 'error',
                  duration: TOAST_DURATION,
                  isClosable: true,
                })
            }
            setLoading(false)
          }
        })
      } else {
        if (isMounted()) {
          setUser(null)
        }
      }
      setLoading(false)
    },
    [uid]
  )

  return {}
}
